module.exports = __webpack_public_path__ + "img/centos.ee31e646.webp";